module.exports = __webpack_public_path__ + "img/bank_01.158b5230.png";